import SolutionSettings from './SolutionSettings';

export default SolutionSettings;
